import { useWeb3React } from '@web3-react/core';
import { Web3Provider } from '@ethersproject/providers';
import { motion, AnimatePresence } from 'framer-motion';
import injected from './NavbarWalletConnectors';
import ReturnButton from './NavbarHomeButton';
import WalletButton from './NavbarWalletButton';
import WalletBalance from './NavbarWalletBalance';

// types
interface IProps {
  sheetToggle: () => void;
}

const Navbar: React.FC<IProps> = ({ sheetToggle }: IProps) => {
  const { active, activate } = useWeb3React<Web3Provider>();

  async function connect() {
    try {
      await activate(injected);
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div className="navbar">
      <ReturnButton />
      <AnimatePresence key="walletButton" exitBeforeEnter>
        {!active ? (
          <motion.div
            key="loginButtonMotion"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <button
              type="button"
              className="navbarLoginButton"
              onClick={connect}
            >
              Login
            </button>
          </motion.div>
        ) : (
          <motion.div
            key="walletButtonMotion"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <WalletButton
              buttonText={<WalletBalance />}
              onClick={sheetToggle}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Navbar;
